var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalAttack(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-244 -2770.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(244 2770.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,15.506l-2.71-4.864L10.643,5.79,15.506,8.5l5.18-2.146L22.209,1H29.07l1.523,5.356L35.773,8.5l4.864-2.71,4.852,4.852-2.71,4.864,2.146,5.18,5.356,1.523V29.07l-5.356,1.522-2.146,5.18,2.71,4.864-4.852,4.852-4.864-2.71-5.18,2.146L29.07,50.279H22.209l-1.522-5.356-5.18-2.146-4.864,2.71L5.791,40.636,8.5,35.773l-2.146-5.18L1,29.07V22.209l5.356-1.523Z",
    transform: "translate(-0.64 -0.639)",
    fill: "none",
    stroke: "#7d92ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.566 2787.644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.812,57.244l-3.928,3.928L39.812,65.1",
    transform: "translate(-35.884 -53.316)",
    fill: "none",
    stroke: "#7d92ac",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.423,57.244l3.928,3.928L96.423,65.1",
    transform: "translate(-76.782 -53.316)",
    fill: "none",
    stroke: "#7d92ac",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: 15.712,
    x2: 3.928,
    transform: "translate(9.82)",
    fill: "none",
    stroke: "#7d92ac",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalAttack);
export default __webpack_public_path__ + "static/media/ExternalAttack.713ae365d5ca4929cd27139b6de6a17f.svg";
export { ForwardRef as ReactComponent };